import {
  BrandLogo,
  COLORS,
  CountdownChip,
  FONT_SIZES,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';

export const StyledCountdownChip = styled(CountdownChip)`
  width: fit-content;
  position: relative;
  bottom: 2px;
  margin: auto;

  ${tabletAndUpLinaria(`
    bottom: initial;
    margin: unset;
  `)}
`;

export const imageCardStyles = `
  position: relative;
  overflow: hidden;
  height: 100%;
  border-radius: 8px;
  aspect-ratio: 1;
  box-shadow: 0.75px 4.5px 6px 0 rgba(0, 0, 0, 0.08),
  0 1.5px 12px 6px rgba(0, 0, 0, 0.07);
`;

export const StyledBrandLogo = styled(BrandLogo)`
  display: flex;
  justify-content: center;
  padding-inline: 24px;
  color: ${COLORS['Text.White']};
  font-size: ${FONT_SIZES.px24};

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px40};
    img {
      height: 100px;
    }
  `)}
`;
